import { createAction } from 'retreon';

export const open = createAction('phonebook/open');
export const close = createAction('phonebook/close');
export const toggle = createAction('phonebook/toggle');
